import React from 'react';
import { PageHeader, Card } from '@/components/Primitives';
import { TID } from '@/constants/testIds/voice';
import { DownloadSimple, Code } from '@phosphor-icons/react';

const PbxConfig = () => {
    const download = (path, filename) => {
        const token = localStorage.getItem('vg_token');
        const url = `${process.env.REACT_APP_BACKEND_URL}${path}`;
        fetch(url, { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => r.blob())
            .then((b) => {
                const a = document.createElement('a');
                a.href = URL.createObjectURL(b);
                a.download = filename;
                a.click();
            });
    };

    return (
        <>
            <PageHeader
                eyebrow="PBX Bridge"
                title="PBX Konfigurace"
                description="Generování Asterisk PJSIP a dialplan souborů z dat v CMS. Nasadíte na vlastní Asterisk / FreeSWITCH server."
            />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <Card title="pjsip.conf">
                    <p className="text-xs mb-3" style={{ color: 'var(--text-secondary)' }}>
                        SIP endpointy pro všechny aktivní klapky, DIDWW trunk a transports (UDP/TCP/TLS).
                        Hesla jsou v souboru zobrazena jako placeholdery — skutečné heslo se nikdy z CMS nevrací,
                        je nutné je zadat při vytvoření klapky a poté nahradit v generovaném config souboru,
                        nebo nakonfigurovat phone provisioning.
                    </p>
                    <button data-testid={TID.pbxDownloadPjsip}
                            onClick={() => download('/api/pbx/config/pjsip.conf', 'pjsip.conf')}
                            className="inline-flex items-center gap-2 px-3 py-2 text-xs font-bold uppercase tracking-[0.08em]"
                            style={{ background: 'var(--brand)', color: '#fff', borderRadius: 2 }}>
                        <DownloadSimple size={14} weight="bold" />Stáhnout
                    </button>
                </Card>

                <Card title="extensions.conf (dialplan)">
                    <p className="text-xs mb-3" style={{ color: 'var(--text-secondary)' }}>
                        Routovací logika pro každé DID číslo: uvítání → IVR → klapka / ring group / GSM / voicemail.
                    </p>
                    <button data-testid={TID.pbxDownloadDialplan}
                            onClick={() => download('/api/pbx/config/extensions.conf', 'extensions.conf')}
                            className="inline-flex items-center gap-2 px-3 py-2 text-xs font-bold uppercase tracking-[0.08em]"
                            style={{ background: 'var(--brand)', color: '#fff', borderRadius: 2 }}>
                        <DownloadSimple size={14} weight="bold" />Stáhnout
                    </button>
                </Card>
            </div>

            <Card title="Kompletní Docker Compose bundle" className="mb-6">
                <p className="text-xs mb-3" style={{ color: 'var(--text-secondary)' }}>
                    ZIP obsahující <code>docker-compose.yml</code>, Asterisk konfigurace, ARI bridge sidecar (Python),
                    aktuálně vygenerované <code>pjsip.conf</code> + <code>extensions.conf</code> a README s instrukcemi.
                    Nahrajte na váš server, doplňte SIP hesla, spusťte <code>docker compose up -d</code>.
                </p>
                <button data-testid="pbx-download-bundle"
                        onClick={() => download('/api/pbx/config/docker-bundle.zip', 'voice-gateway-pbx-bundle.zip')}
                        className="inline-flex items-center gap-2 px-3 py-2 text-xs font-bold uppercase tracking-[0.08em]"
                        style={{ background: 'var(--brand)', color: '#fff', borderRadius: 2 }}>
                    <DownloadSimple size={14} weight="bold" />Stáhnout bundle (ZIP)
                </button>
            </Card>

            <Card title="Webhooky pro PBX">
                <p className="text-xs mb-3" style={{ color: 'var(--text-secondary)' }}>
                    Volání těchto endpointů zajistí synchronizaci dat z vašeho PBX/SBC zpět do CMS.
                </p>
                <div className="space-y-3 font-mono text-xs">
                    {[
                        ['POST', '/api/webhooks/incoming-call', '{ "did_number": "+420...", "caller_id": "+420...", "started_at": "ISO" } → vrací call_id a flow'],
                        ['POST', '/api/webhooks/call-finished', '{ "call_id": "...", "status": "answered|missed|failed|busy", "duration_seconds": 23, "extension_id": "..." }'],
                        ['POST', '/api/webhooks/voicemail', '{ "extension_id": "...", "caller_id": "+420...", "audio_url": "https://...", "duration_seconds": 12 }'],
                    ].map(([m, p, d]) => (
                        <div key={p} className="px-3 py-2"
                             style={{ background: '#06080A', borderRadius: 2 }}>
                            <div className="flex gap-3">
                                <span className="text-[var(--brand)] font-bold">{m}</span>
                                <span>{p}</span>
                            </div>
                            <div className="mt-1" style={{ color: 'var(--text-secondary)' }}>{d}</div>
                        </div>
                    ))}
                </div>
            </Card>
        </>
    );
};

export default PbxConfig;
